import { LitElement, html } from 'lit-element';
import translate from '../../utils/webcomponents/translate';

import './alert-item';

const RESOURCE = 'alerts';

const tableHeader = () => html`
	<div class="table__header">
		<div class="table__heading manageable-list__item-action"></div>
		<div class="table__heading">${translate(RESOURCE, 'name', 'Name')}</div>
		<div class="table__heading">${translate(RESOURCE, 'condition', 'Condition')}</div>
		<div class="table__heading">${translate(RESOURCE, 'alertType', 'Alert type')}</div>
		<div class="table__heading text-right">${translate(RESOURCE, 'price', 'price')}</div>
		<div class="table__heading">${translate(RESOURCE, 'triggered', 'triggered')}</div>
	</div>`;

class AlertsTable extends LitElement {
	static get properties() {
		return {
			items: { type: Array },
		};
	}

	render() {
		return html`
			<div class="table-container">
				<div class="table">
					${tableHeader()}

					<div class="table__body">
						${this.items.map(item => html`
							<x-alert-item
								class="table__row manageable-list__item"
								.item="${item}">
							</x-alert-item>`)}
					</div>
				</div>
			</div>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-alerts-table', AlertsTable);

export default AlertsTable;
